import { KycFileCertificationStatus } from '@dealstack/shared/lib/generated';

/** Nothing to show for a proof that needs no certifying and has none. */
export const hasCertificationToShow = (
	status: KycFileCertificationStatus,
	certificationRequired: boolean
): boolean => certificationRequired || status !== KycFileCertificationStatus.UNCERTIFIED;

/** Certified copies are final; everything else can still be changed by the investor. */
export const canChangeCertification = (status: KycFileCertificationStatus): boolean =>
	status !== KycFileCertificationStatus.CERTIFIED;
